// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__17sQZ","LoaderText":"Loader_LoaderText__R589P"};